// extracted by mini-css-extract-plugin
export default {"imgdiv":"c12e949424 dbbf26534b","img":"_62cb7af88f _8ae7febb7b"};